import React, { useContext, useCallback } from 'react';
import NumericKeypad from 'components/common/modals/NumericKeypad';
import numericFeedbackCtx from 'context/numericfeedback';

// Returns a function that opens the on-screen numeric keypad and resolves with
// the value the user entered (or `undefined` if they cancelled).
const useNumericKeypad = () => {
	const { add, remove } = useContext(numericFeedbackCtx);

	return useCallback(
		({ initialValue = '', prepend, min, max, allowDecimals = true } = {}) =>
			new Promise(resolve => {
				const close = value => {
					remove();
					resolve(value);
				};

				add(
					<NumericKeypad
						initialValue={initialValue}
						prepend={prepend}
						min={min}
						max={max}
						allowDecimals={allowDecimals}
						onClose={close}
					/>,
				);
			}),
		[add, remove],
	);
};

export default useNumericKeypad;
